/* ============================================
   Polygraphist Theme — Main JS
   ============================================ */

(function () {
    'use strict';

    // ---- Remove ALL inline <style> tags from page content ----
    // Page content from Ghost contains full HTML documents with their own
    // <style> blocks. When browser parses nested HTML, styles may end up
    // outside .pg-content. We strip ALL non-theme styles.
    function stripInlineStyles() {
        var content = document.querySelector('.pg-content');
        if (!content) return;

        // Remove all <style> tags inside pg-content
        var contentStyles = content.querySelectorAll('style');
        contentStyles.forEach(function (el) {
            el.remove();
        });

        // Also remove any <style> in the document that contain page-content
        // CSS classes (not our theme styles)
        var allStyles = document.querySelectorAll('style');
        allStyles.forEach(function (el) {
            var text = el.textContent || '';
            // Detect content-injected styles by checking for known page classes
            if (text.indexOf('.hero-section') !== -1 && text.indexOf('.homepage') !== -1) {
                el.remove();
            }
            if (text.indexOf('.services-page') !== -1 || text.indexOf('.about-page') !== -1 ||
                text.indexOf('.pricing-page') !== -1 || text.indexOf('.screening-page') !== -1 ||
                text.indexOf('.contacts-section') !== -1) {
                el.remove();
            }
            // Reviews page has its own full HTML with styles
            if (text.indexOf('.review-card') !== -1 && text.indexOf('.nav-links') !== -1) {
                el.remove();
            }
        });

        // Remove inline navigation/footer from reviews page (has its own <header>/<footer>)
        var inlineHeaders = content.querySelectorAll('header');
        inlineHeaders.forEach(function(el) {
            if (el.querySelector('.nav-links') || el.querySelector('.logo')) {
                el.remove();
            }
        });

        var inlineFooters = content.querySelectorAll('footer');
        inlineFooters.forEach(function(el) {
            el.remove();
        });

        // Remove nested <html>, <head>, <body> text nodes that browser might render
        // These appear as text like "<!DOCTYPE html>" etc.
        var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
        var toRemove = [];
        while (walker.nextNode()) {
            var text = walker.currentNode.textContent.trim();
            if (text === '<!DOCTYPE html>' || text === '' ) {
                continue; // browser strips these automatically
            }
        }
    }

    // ---- Burger menu ----
    function initBurger() {
        var burger = document.querySelector('.pg-burger');
        if (!burger) return;

        burger.addEventListener('click', function () {
            document.body.classList.toggle('nav-open');
        });

        // Close on nav link click (mobile)
        var navLinks = document.querySelectorAll('.pg-header-nav a');
        navLinks.forEach(function (link) {
            link.addEventListener('click', function () {
                document.body.classList.remove('nav-open');
            });
        });

        // Close on escape
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                document.body.classList.remove('nav-open');
            }
        });
    }

    // ---- Responsive video iframes ----
    function initResponsiveVideos() {
        if (typeof reframe === 'function') {
            reframe('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
        }
    }

    // ---- Lightbox ----
    function initLightbox() {
        if (typeof initPhotoSwipe === 'function') {
            initPhotoSwipe('.pg-content');
        }
    }

    // ---- Add reveal classes to page content sections ----
    function addRevealClasses() {
        var selectors = [
            '.service-card', '.advantage-item', '.principle-card',
            '.quality-item', '.qual-card', '.factor-card',
            '.level-card', '.offer-card', '.review-card',
            '.step', '.info-block', '.contact-item',
            '.discount-card', '.cta-card'
        ];

        selectors.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
                el.classList.add('reveal');
            });
        });
    }

    // ---- Init ----
    document.addEventListener('DOMContentLoaded', function () {
        stripInlineStyles();
        initBurger();
        initResponsiveVideos();
        initLightbox();
        addRevealClasses();
    });
})();
